import { EntityLike } from '@entities/models';
import { EntityType, EntityTypes } from '@entities/types';
import { WizardBasketItem } from '@wizard/models';
import { WizardItemEntity } from '../models';

export const normalizeColumnType = (item: WizardBasketItem | WizardItemEntity | EntityLike): EntityType => {
  let type = item['type'];
  if (typeof type === 'number') {
    console.warn(`⚠️ [Colonne] ERROR in TYPE => ${type}`);
    return EntityTypes.Attribute;
  }
  return type as EntityType;
};
